import { useDealerDiscounts } from "app/hooks/checkout/useDealerDiscounts";
import { useMemo } from "react";
import { CategoryStandardProduct } from "shared/api/middleware-api-client";
import Text from "shared/ui/typography/Text";
import { concatClassnames } from "shared/utils/concatClassnames";

interface CheckoutPanelItemPriceProps {
  standardProduct: CategoryStandardProduct;
}

const StandardProductPrice = ({
  standardProduct,
}: CheckoutPanelItemPriceProps) => {
  const { dealerDiscounts, isDealerDiscountsLoading } = useDealerDiscounts();

  const standardProductDiscounts = useMemo(() => {
    return dealerDiscounts?.find(
      (discount) => discount.productCode === standardProduct.productType.code,
    );
  }, [dealerDiscounts, standardProduct.productType.code]);

  const originalPrice = standardProduct.price * (standardProduct.amount || 1);
  const businessDiscount = standardProductDiscounts?.discount ?? 0;
  const businessDoorDiscountsPrice =
    originalPrice - (originalPrice * businessDiscount) / 100;

  const showDiscount =
    standardProductDiscounts && originalPrice !== businessDoorDiscountsPrice;

  return (
    <div className="gg-w-full gg-text-right">
      {showDiscount && (
        <p className="gg-text-sm gg-text-purple-300 gg-line-through">
          €{businessDoorDiscountsPrice}
        </p>
      )}
      <Text className={concatClassnames("gg-text-lg gg-font-bold")}>
        €{originalPrice.toFixed(2)}
      </Text>
    </div>
  );
};
export default StandardProductPrice;
